import { canUseEventBridge, currentDrift, round, timeStampNow } from '@datadog/browser-core';
export function startDefaultContext(hooks, configuration, sdkName) {
  hooks.register(0 /* HookNames.Assemble */, function (_ref) {
    var eventType = _ref.eventType;
    var source = configuration.source;
    return {
      type: eventType,
      _dd: {
        format_version: 2,
        drift: currentDrift(),
        configuration: {
          session_sample_rate: round(configuration.sessionSampleRate, 3),
          session_replay_sample_rate: round(configuration.sessionReplaySampleRate, 3),
          profiling_sample_rate: round(configuration.profilingSampleRate, 3),
          trace_sample_rate: round(configuration.traceSampleRate, 3),
          beta_encode_cookie_options: configuration.betaEncodeCookieOptions
        },
        browser_sdk_version: canUseEventBridge() ? "6.31.0" : undefined,
        sdk_name: sdkName
      },
      application: {
        id: configuration.applicationId
      },
      date: timeStampNow(),
      source: source
    };
  });
  hooks.register(1 /* HookNames.AssembleTelemetry */, function () {
    return {
      application: {
        id: configuration.applicationId
      }
    };
  });
}